export default function marquee() {
    const marqueeWrap = document.querySelector('.js--marquee');

    if (!marqueeWrap) return;

    const strip = marqueeWrap.querySelector('.n-marquee__strip');
    const wrapWidth = marqueeWrap.offsetWidth;
    const stripWidth = strip.offsetWidth;

    function animateMarqueeStrip() {
        strip.classList.remove('animation-ended');
        strip.style = `transform: translateX(-${stripWidth + wrapWidth}px);`;
        strip.addEventListener('transitionend', () => {
            strip.classList.add('animation-ended');
            strip.style = 'transform: translateX(0);';
            strip.addEventListener('transitionend', animateMarqueeStrip, { once: true });
        }, { once: true });
    }

    animateMarqueeStrip();
}
